var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmploymentVerificationLetterOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.778 2h.042a1.667 1.667 0 011.624 1.625v16.751a1.667 1.667 0 01-1.624 1.623l-.042.001H5.834a3.333 3.333 0 01-3.278-3.279v-7.586a.833.833 0 01.802-.8h.03l2.5-.002V3.667l.001-.043a1.667 1.667 0 011.625-1.623L7.556 2h12.222zm-.556 1.667H8.112a.556.556 0 00-.556.527V17l-.001.042a1.667 1.667 0 01-1.624 1.624h-.042V12H4.222v6.155A2.222 2.222 0 006.4 20.333h12.85a.556.556 0 00.527-.527V4.194a.556.556 0 00-.526-.527h-.029zm-1.11 11.11a.556.556 0 01.027 1.111H9.222a.556.556 0 01-.027-1.11h8.917zm0-2.221a.556.556 0 01.027 1.11H9.222a.556.556 0 01-.027-1.11h8.917zm0-2.223a.556.556 0 01.027 1.11l-.028.001H9.222a.556.556 0 01-.027-1.11h8.917zm-5.556-2.222a.556.556 0 01.027 1.11l-.027.001H9.222a.556.556 0 01-.027-1.11h3.361z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentVerificationLetterOutline);
export default __webpack_public_path__ + "59b916c85155a8f7251bf52ac3f406ed.svg";
export { ForwardRef as ReactComponent };